import createEmojiPickerViewState from './createEmojiPickerViewState';
import createGifPickerViewState from './createGifPickerViewState';
import setExpressionPickerViewStateToExpressionId from '../actions/setExpressionPickerViewStateToExpressionId';
import expressionStore from '../store/expressionStore';
import ExpressionPage from '../store/schema/ExpressionPage';
import ExpressionPickerViewState from 'owa-expressions-store/lib/store/schema/ExpressionPickerViewState';
import { isFeatureEnabled } from 'owa-feature-flags';

export default async function getOrInitExpressionPickerViewState(
    expressionId: string
): Promise<ExpressionPickerViewState> {
    let expressionPickerViewState: ExpressionPickerViewState = expressionStore.expressionPickerViewStates.get(
        expressionId
    );

    if (
        !expressionPickerViewState ||
        (isFeatureEnabled('cmp-gifPicker') && !expressionPickerViewState.gifPickerViewState)
    ) {
        // Initialize expressionPickerViewState and set to expressionId in store
        // Reinitialize if gifPickerViewState is null, in case cmp-gifPicker
        // was toggled after initialization
        expressionPickerViewState = await initializeExpressionPickerViewState(expressionId);
        setExpressionPickerViewStateToExpressionId(expressionId, expressionPickerViewState);
    }

    return expressionPickerViewState;
}

async function initializeExpressionPickerViewState(
    expressionId
): Promise<ExpressionPickerViewState> {
    return {
        expressionId: expressionId,
        isOpen: false,
        isSearching: false,
        searchTerm: '',
        page: isFeatureEnabled('cmp-gifPicker') ? ExpressionPage.All : ExpressionPage.Emojis,
        wordToReplace: '',
        emojiPickerViewState: createEmojiPickerViewState(),
        gifPickerViewState: isFeatureEnabled('cmp-gifPicker')
            ? await createGifPickerViewState()
            : null,
        source: null,
        paneType: null,
        numSearchesToInsertEmoji: 0,
        emojiCategoryIndex: 0,
        shouldRestoreSelectionAfterInsertNode: false,
        editorAdapter: null,
    };
}
